
var m;

/**
 * 公共表单数据清空
 */

export function clearForm(data) {
  for(let i in data){
    if(i!=='pageCount' && i!='pageSize')
      data[i] = ''
  }
  return data;
}


/**
 * 根据身份证获取年龄
 */
export function getAge(ageInfo){
  if(ageInfo!=''&&ageInfo!=null&&ageInfo!=undefined){
    let year = ageInfo.substring(6,10);     //截取身份证上的年
    let months = ageInfo.substring(10,12);  //截取身份证上的月
    let days = ageInfo.substring(12,14);    //截取身份证上的日
    let myDate = new Date();
    let month = myDate.getMonth() + 1;
    let day = myDate.getDate();
    let age = myDate.getFullYear() - year - 1;
    if (months<= month && days <= day) {
      age++;
    }
    return age;
  }else{
    return "暂无年龄"
  }
}

export function jsGetAge(ageInfo) {
  let year = ageInfo.substring(0,4);     //截取身份证上的年
  let months = ageInfo.substring(6,7);  //截取身份证上的月
  let days = ageInfo.substring(9,10);
  let myDate = new Date();
  let month = myDate.getMonth() + 1;
  let day = myDate.getDate();
  let age = myDate.getFullYear() - year - 1;
  if (months<= month && days <= day) {
    age++;
  }
  return age;

}

/**
 * 判断手机号正则
 * @param name
 * @returns {*}
 */
export function checkPhone(phone,_this) {
  let partten = /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/; //手机号正则
  let fixedTelArea = /^[0][1-9]{2,3}-[0-9]{5,10}$/; //带区号的固定电话
  let fixedTel = /^[1-9]{1}[0-9]{5,8}$/;   //不带区号的固定电话

  if(partten.test(phone)){
    return true
  }else if(fixedTelArea.test(phone)){
    return true
  }else if(fixedTel.test(phone)){
    return true
  }else{
    _this.$message.error('请输入正确的手机号码或者固定电话号码！');
    return false
  }
}


//获取cookie、
export function getCookie(name) {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)){
    return unescape(arr[2]);
  }else
    return null;
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, minutes) {
  let exdate = new Date();
  exdate.setMinutes(exdate.getMinutes() + minutes, exdate.getSeconds(), 0);
  document.cookie = c_name + "=" + escape(value) + ((minutes == null) ? "" : ";expires=" + exdate.toGMTString());
};

//删除cookie
export function delCookie(name) {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

/**
 * 获取token
 * @returns {*}
 */
export function getToken() {
  let token = getCookie(process.env.sessionName)
  return token;
}

export function requestError(msg, self) {
  if (msg == '请先登录!' || msg == '您的账号在别处登录,请重新登录!') {
    self.$message.error(msg);
    delCookie(process.env.sessionName);
    self.$router.push({path: '/'});
  } else {
    self.$message.warning(msg);
  }
}


Date.prototype.Format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

/**
 * 将指定日期转换为对应时区的时间
 * @param date 时间类型
 * @param i 将要转换到的时区
 *
 */
export function zoneResolver(date, i) {
  let localTime = date.getTime();
  let localOffset = date.getTimezoneOffset() * 60000; //获得当地时间偏移的毫秒数
  let utc = localTime + localOffset; //utc即GMT时间
  let hawaii = utc + (3600000 * i);
  return new Date(hawaii);
}

/**
 * 身份证校验
 * @param id
 * @returns {*}
 */
export function isSfz(id) {
  // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
  let format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  //号码规则校验
  if (!format.test(id)) {
    return {'status': false, 'msg': '身份证号码不合规'};
  }
  //区位码校验
  //出生年月日校验   前正则限制起始年份为1900;
  let year = id.substr(6, 4),//身份证年
    month = id.substr(10, 2),//身份证月
    date = id.substr(12, 2),//身份证日
    time = Date.parse(month + '-' + date + '-' + year),//身份证日期时间戳date
    now_time = Date.parse(new Date()),//当前时间戳
    dates = (new Date(year, month, 0)).getDate();//身份证当月天数
  if (time > now_time || date > dates) {
    return {'status': 0, 'msg': '出生日期不合规'}
  }
  //校验码判断
  let c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);   //系数
  let b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');  //校验码对照表
  let id_array = id.split("");
  let sum = 0;
  for (let k = 0; k < 17; k++) {
    sum += parseInt(id_array[k]) * parseInt(c[k]);
  }
  if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
    return {'status': false, 'msg': '身份证校验码不合规'}
  }
  return {'status':true, 'msg': '校验通过'}
}




// WEBPACK FOOTER //
// ./src/until/until.js